import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ArtworkThumb } from '../_artwork/artwork.thumb';
import { LoadingComponent } from '../shared/loading/loading.component';
import { TransitionComponent } from '../shared/transition/transition.component';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './collection.scss';

@inject('appStore', 'routerStore')
@observer
export class CollectionComponent extends Component {

    getLighting(width) {
        var lights = [], i;
        for (i = 1; i < 5; i++) {
            lights.push(<div className={`collection-light collection-light--${i}`} key={i} />);
        }

        return <div className='collection-lights' style={{width: width}}>
            {lights}
        </div>;
    }

    getComponent() {
        const { collection } = this.props;

        let outerStyles = {},
            innerStyles = {},
            thumbs = [],
            ratio = 1;

        if (collection) {
            ratio = (parseFloat(collection.Width, 10) / parseFloat(collection.Height, 10)).toFixed(4);
            innerStyles.width = `calc(90vh * ${ratio})`;
        }

        if (collection && collection.BackgroundColor) {
            outerStyles.backgroundColor = collection.BackgroundColor;
        }

        if (collection) {
            thumbs = collection.Artwork.map(function(artwork, index) {
                return (<ArtworkThumb
                    collection={collection}
                    artwork={artwork}
                    index={index}
                    key={index}
                    ratio={ratio}
                />);
            });

            return (
                <div key='collection'>
                    <div className='collection' style={outerStyles}>
                        <div className='collection-inner' style={innerStyles} id='collectionInner'>
                            {this.getLighting(innerStyles.width)}
                            <div className='artwork-thumbs'>
                                <ReactCSSTransitionGroup
                                    transitionAppear
                                    transitionAppearTimeout={350}
                                    transitionEnterTimeout={0}
                                    transitionLeaveTimeout={0}
                                    transitionName='fadeInThumb'>
                                    {thumbs}
                                </ReactCSSTransitionGroup>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingComponent />
            );
        }
    }

    render() {
        return <TransitionComponent>
            {this.getComponent()}
        </TransitionComponent>;
    }

}



// WEBPACK FOOTER //
// ./src/_collection/collection.component.js